/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 */


// template IDs
var TEMPLATE_DEFAULT = 1;
var TEMPLATE_HOMEPAGE = 4;
var TEMPLATE_EVENT_REGISTRATION = 7;
var TEMPLATE_EVENT_POSTER = 8;
var TEMPLATE_EVENT_MOVIE_POLL = 9;


var page;
var templateId = parseInt(document.documentElement.getAttribute('data-template'));


$(document).ready(function () {
	var body = $('body');

	/*
	 * Template-specific init
	 */
	switch(templateId){
		case TEMPLATE_HOMEPAGE:
			break;

		case TEMPLATE_EVENT_REGISTRATION:
			page = new EventRegistrationController(body);
			break;

		case TEMPLATE_EVENT_POSTER:
			page = new EventPosterController(body);
			break;

		case TEMPLATE_EVENT_MOVIE_POLL:
			page = new EventMoviePollController(body);
			break;

		case TEMPLATE_DEFAULT:
			break;
	}
	

	/**
	 * Global init
	 */
	var cookieBar = new CookieBar('#cookie-bar', 'cookies-agree', 1);
	
});
